export const signupValidators = {
  name: {
    rules: [
      {
        test: (value) => {
          return !validationRules.isEmptyString(value);
        },
        message: "Please Enter Full Name",
      },
    ],
    errors: [],
    valid: false,
  },
  company: {
    rules: [
      {
        test: (value) => {
          return !validationRules.isEmptyString(value);
        },
        message: "Please Enter Company Name ",
      },
    ],
    errors: [],
    valid: false,
  },
  username: {
    rules: [
      {
        test: (value) => {
          return !validationRules.isEmptyString(value);
        },
        message: "Please Enter Work Email",
      },
      {
        test: (value) => {
          return validationRules.isEmail(value);
        },
        message: "Invalid email id",
      },
    ],
    errors: [],
    valid: false,
  },
  password: {
    rules: [
      {
        test: (value) => {
          return !validationRules.isEmptyString(value);
        },
        message: "Please Enter Password",
      },
      {
        test: (value) => {
          return validationRules.isStrongPassword(value);
        },
        message:
          "Password should contain atleast 1 upper case,1 lower case,1 number ,1 special character of length between 6 to 12 ",
      },
    ],
  },
  confirmPassword: {
    rules: [
      {
        test: (value) => {
          return !validationRules.isEmptyString(value);
        },
        message: "Please Enter Confirm password",
      }, //   {
      //     test: value => {
      //       return validationRules.isStrongPassword(value);
      //     },
      //     message:
      //       "Confirm password should contain atleast 1 upper case,1 lower case,1 number ,1 special character of length between 6 to 12 "
      //   },
      {
        test: (value1, value2) => {
          return validationRules.equals(value1, value2);
        },
        message: "Confirm password should match with password ",
      },
    ],
  },
  country: {
    rules: [
      {
        test: (value) => {
          return !validationRules.isEmptyString(value) && !validationRules.isUndefined(value);
        },
        message: "Please select a country",
      },
    ],
  },
  disclaimer: {
    rules: [
      {
        test: (value) => {
          return validationRules.isTrue(value);
        },
        message: "Please acknowledge the Disclaimer",
      },
    ],
  },
  errorSummary: [],
};

export const loginValidators = {
  username: {
    rules: [
      {
        test: (value) => {
          return !validationRules.isEmptyString(value);
        },
        message: "Please Enter Email",
      },
      {
        test: (value) => {
          return validationRules.isEmail(value);
        },
        message: "Invalid email id",
      },
    ],
  },
  password: {
    rules: [
      {
        test: (value) => {
          return !validationRules.isEmptyString(value);
        },
        message: "Please Enter Password",
      },
    ],
  },
  errorSummary: [],
};

export const forgotPasswordValidators = {
  username: {
    rules: [
      {
        test: (value) => {
          return !validationRules.isEmptyString(value);
        },
        message: "Please Enter Email",
      },
      {
        test: (value) => {
          return validationRules.isEmail(value);
        },
        message: "Invalid email id",
      },
    ],
    errors: [],
    valid: false,
  },
  errorSummary: [],
};
export const resetPasswordValidators = {
  password: {
    rules: [
      {
        test: (value) => {
          return !validationRules.isEmptyString(value);
        },
        message: "Please EnterPassword",
      },
      {
        test: (value) => {
          return validationRules.isStrongPassword(value);
        },
        message:
          "Password should contain atleast 1 upper case,1 lower case,1 number ,1 special character of length between 6 to 12 ",
      },
    ],
  },
  confirmpassword: {
    rules: [
      {
        test: (value) => {
          return !validationRules.isEmptyString(value);
        },
        message: "Please Enter Confirm password",
      }, //   {
      //     test: value => {
      //       return validationRules.isStrongPassword(value);
      //     },
      //     message:
      //       "Confirm password should contain atleast 1 upper case,1 lower case,1 number ,1 special character of length between 6 to 12 "
      //   },
      {
        test: (value1, value2) => {
          return validationRules.equals(value1, value2);
        },
        message: "Confirm password should match with password ",
      },
    ],
  },
  errorSummary: [],
};

export const singleEmaildValidators = {
  email: {
    rules: [
      {
        test: (value) => {
          return !validationRules.isEmptyString(value);
        },
        message: "Please Enter Email",
      },
      {
        test: (value) => {
          return validationRules.isEmail(value);
        },
        message: "Invalid email format",
      },
    ],
    errors: [],
    valid: false,
  },
  errorSummary: [],
};

export const profileSecurityValidators = {
  oldpassword: {
    rules: [
      {
        test: (value) => {
          return !validationRules.isEmptyString(value);
        },
        message: "Please Enter Password",
      },
    ],
  },
  newpassword: {
    rules: [
      {
        test: (value) => {
          return !validationRules.isEmptyString(value);
        },
        message: "Please Enter New Password",
      },
      {
        test: (value) => {
          return validationRules.isStrongPassword(value);
        },
        message:
          "New Password should contain atleast 1 upper case,1 lower case,1 number ,1 special character of length between 6 to 12 ",
      },
      {
        test: (value1, value2) => {
          return !validationRules.equals(value1, value2);
        },
        message: "Old password and New password can not be same",
      },
    ],
  },
  confirmpassword: {
    rules: [
      {
        test: (value) => {
          return !validationRules.isEmptyString(value);
        },
        message: "Please Enter Confirm password",
      },
      {
        test: (value1, value2) => {
          return validationRules.equals(value1, value2);
        },
        message: "Confirm password should match with new password ",
      },
    ],
  },
  errorSummary: [],
};

export const profileGeneralValidators = {
  name: {
    rules: [
      {
        test: (value) => {
          return !validationRules.isEmptyString(value);
        },
        message: "Please Enter First Name",
      },
    ],
  },
  CompanyName: {
    rules: [
      {
        test: (value) => {
          return !validationRules.isEmptyString(value);
        },
        message: "Please Enter Company Name",
      },
    ],
  },
  mobilenumber: {
    rules: [
      {
        test: (value) => {
          return validationRules.isMobileNumber(value);
        },
        message: "Invalid Mobile number",
      },
    ],
  },
  zipcode: {
    rules: [
      {
        test: (value) => {
          return validationRules.isZipcode(value);
        },
        message: "Invalid Zipcode",
      },
    ],
  },
  errorSummary: [],
};
export const updateValidators = (validators, fieldName, value, val2) => {
  if (validators[fieldName] == undefined) return;

  validators[fieldName].errors = [];
  validators[fieldName].valid = true;
  validators[fieldName].rules.forEach((rule) => {
    if (validators[fieldName].errors.length > 0) return;

    if (rule.test instanceof RegExp) {
      if (!rule.test.test(value)) {
        if (fieldName == "email") {
          validators[fieldName].errors = [];
          validators.errorSummary = [];
        }
        validators[fieldName].errors.push(rule.message);
        if (validators.errorSummary.indexOf(rule.message) < 0) validators.errorSummary.push(rule.message);
        validators[fieldName].valid = false;
      } else {
        validators.errorSummary = validators.errorSummary.filter((err) => err != rule.message);
      }
    } else if (typeof rule.test === "function") {
      if (!rule.test(value, val2)) {
        if (fieldName == "email") {
          validators[fieldName].errors = [];
          validators.errorSummary = [];
        }
        validators[fieldName].errors.push(rule.message);
        if (validators.errorSummary.indexOf(rule.message) < 0) validators.errorSummary.push(rule.message);

        validators[fieldName].valid = false;
      } else {
        validators.errorSummary = validators.errorSummary.filter((err) => err != rule.message);
      }
    }
  });
};

export const initValidations = (validators) => {
  Object.keys(validators).forEach((fieldName) => {
    if (fieldName != "errorSummary") updateValidators(validators, fieldName, "");
  });
};

// This function resets all validators for this form to the default state
export const resetValidators = (validators) => {
  Object.keys(this.validators).forEach((fieldName) => {
    this.validators[fieldName].errors = [];
    this.validators[fieldName].state = "";
    this.validators[fieldName].valid = false;
  });
};

// This function displays the validation errors for a given input field
export const displayValidationErrors = (validators) => {
  let errMessages = "";

  if (validators && validators.errorSummary.length > 0) {
    const errors = validators.errorSummary.map((info, index) => {
      if (errMessages.indexOf(info) < 0) errMessages = errMessages + "<li>" + info + "<br/></li>";
    });
  }
  return errMessages;
};

// This method checks to see if the validity of all validators are true
export const isFormValid = (validators) => {
  let status = true;
  Object.keys(validators).forEach((field) => {
    if (!validators[field].valid) {
      status = false;
    }
  });
  return status;
};

const isExist = (value) => {
  return value !== null && value !== undefined;
};

const isEmpty = (value) => {
  return value === "";
};

const validationRules = {
  isDefaultRequiredValue: (value) => {
    return value === undefined || value === "";
  },
  isExist: (value) => {
    return isExist(value);
  },
  matchRegexp: (value, regexp) => {
    return !isExist(value) || isEmpty(value) || regexp.test(value);
  },
  isUndefined: (value) => {
    return value === undefined;
  },
  isEmptyString: (value) => {
    return isEmpty(value);
  },
  isEmail: (value) => {
    return validationRules.matchRegexp(
      value,
      /^((([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*)|((\x22)((((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(([\x01-\x08\x0b\x0c\x0e-\x1f\x7f]|\x21|[\x23-\x5b]|[\x5d-\x7e]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(\\([\x01-\x09\x0b\x0c\x0d-\x7f]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))))*(((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(\x22)))@((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))$/i
    ); //eslint-disable-line no-control-regex
  },
  isUrl: (value) => {
    return validationRules.matchRegexp(
      value,
      /^(https?|s?ftp):\/\/(((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:)*@)?(((\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5]))|((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.?)(:\d*)?)(\/((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)+(\/(([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)*)*)?)?(\?((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|[\uE000-\uF8FF]|\/|\?)*)?(#((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|\/|\?)*)?$/i
    );
  },
  isTrue: (value) => {
    return value === true;
  },
  isFalse: (value) => {
    return value === false;
  },
  isNumeric: (value) => {
    if (typeof value === "number") {
      return true;
    }
    return validationRules.matchRegexp(value, /^[-+]?(?:\d*[.])?\d+$/);
  },
  isAlpha: (value) => {
    return validationRules.matchRegexp(value, /^[A-Z]+$/i);
  },
  isAlphanumeric: (value) => {
    return validationRules.matchRegexp(value, /^[0-9A-Z]+$/i);
  },
  isInt: (value) => {
    return validationRules.matchRegexp(value, /^(?:[-+]?(?:0|[1-9]\d*))$/);
  },
  isFloat: (value) => {
    return validationRules.matchRegexp(value, /^(?:[-+]?(?:\d+))?(?:\.\d*)?(?:[eE][\+\-]?(?:\d+))?$/);
  },
  isWords: (value) => {
    return validationRules.matchRegexp(value, /^[A-Z\s]+$/i);
  },
  isSpecialWords: (value) => {
    return validationRules.matchRegexp(value, /^[A-Z\s\u00C0-\u017F]+$/i);
  },
  isStrongPassword: (value) => {
    return validationRules.matchRegexp(value, /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])(?=.{6,12})/);
  },
  isMobileNumber: (value) => {
    return validationRules.matchRegexp(value, /^((\+)?(\d{2}[-]))?(\d{10}){1}?$/);
  },
  isZipcode: (value) => {
    return validationRules.matchRegexp(value, /^(\d{5}([\-]\d{4})?)/);
  },

  isLength: (value, length) => {
    return !isExist(value) || isEmpty(value) || value.length === length;
  },
  equals: (value, eql) => {
    return !isExist(value) || isEmpty(value) || value == eql;
  },
  maxLength: (value, length) => {
    return !isExist(value) || value.length <= length;
  },
  minLength: (value, length) => {
    return !isExist(value) || isEmpty(value) || value.length >= length;
  },
};



// WEBPACK FOOTER //
// ./src/utility/validations.js